import {APP_INITIALIZER, NgModule, Provider} from '@angular/core';
import {provideTransloco, TranslocoModule} from '@jsverse/transloco';
import {provideTranslocoLocale} from '@jsverse/transloco-locale';
import {provideTranslocoMessageformat} from '@jsverse/transloco-messageformat';
import {TranslationsHelperService} from 'translations.helper.service';
import {CoreConfigService} from '../@core/services/config.service';
import {environment} from '../environments/environment';

import {TranslocoHttpLoader} from './transloco-http-loader';

export const selectedLanguageProvider: Provider = {
    provide: APP_INITIALIZER,
    deps: [CoreConfigService, TranslationsHelperService],
    useFactory: ( coreConfigService: CoreConfigService, langHelper: TranslationsHelperService ) => () => {
            coreConfigService.getConfig()
                .subscribe(config=> {
                    langHelper.changeLanguage(config?.app.appLanguage || environment.locale.defaultLanguage)
                });
    },
    multi: true,
};

@NgModule({
    exports: [ TranslocoModule ],
    providers: [
        selectedLanguageProvider,
        provideTranslocoLocale(),
        provideTranslocoMessageformat(),
        provideTransloco({
            config: {
                availableLangs: environment.locale?.availableLanguages,
                defaultLang: environment.locale?.defaultLanguage,
                // Remove this option if your application doesn't support changing language in runtime.
                reRenderOnLangChange: true,
                prodMode: environment.production,
                missingHandler: {
                    useFallbackTranslation: true,
                    logMissingKey:true,
                    allowEmpty:true
                },
                fallbackLang: 'terms'
            },
            loader: TranslocoHttpLoader
        }),
    ],
})
export class TranslocoRootModule {}
